App.StaticPagesIndexController = Em.Controller.extend
  needs: [ 'staticPages' ]

  env:     Em.inject.service('environment')
  
  pagesBinding: 'model'


  actions:
    openStaticPage: (page) ->
      @transitionToRoute 'static-pages.static-page.edit', page.get('id')
